module.exports = __webpack_public_path__ + "img/avatar2.5ab0d338.jpg";